import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation, useHistory } from 'react-router-dom';
import SubHeader from 'components/SubHeader';
import StatusBar from 'components/StatusBar';
import StatusTooltip from 'components/StatusTooltip';
import { Content } from 'components/BookingMain/styles';
import CheckInRoutes from './Components/CheckInRoutes';
import FooterBar from 'components/FooterBar';
import Spinner from 'components/Spinner';
import { useQuery } from '@apollo/client';
import { GET_GROUP_DETAILS_BY_GROUP_ID } from 'graphql/service';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';
import { debouncedErrorMessage } from 'utils/messageUtil';
import {
  DEFAULT_CHECK_IN_HOUR,
  DEFAULT_CHECK_IN_MINUTE,
  DEFAULT_CUT_OFF_HOUR,
  DEFAULT_CUT_OFF_MINUTE
} from 'constants/constant';

const GroupCheckIn = (props) => {

  const history = useHistory()
  const location = useLocation()
  const pathSegments = location.pathname?.split('/');
  const groupId = pathSegments[pathSegments.length - 1];
  const [groupStatus, setGroupStatus] = useState('')
  const [groupName, setGroupName] = useState('')
  const [earlyCheckInBookings, setEarlyCheckInBookings] = useState(null)

  const { data: groupData, loading, error } = useQuery(GET_GROUP_DETAILS_BY_GROUP_ID, {
    variables: { groupId: groupId },
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    onCompleted: (groupData) => {
      if(groupData) {
        const { name, status, bookings } = groupData.groupByID
        setGroupStatus(status)
        setGroupName(name)
        const newEarlyCheckInBookings = bookings.filter(booking => ((moment().tz(TIME_ZONE) < moment(booking.checkInDate).tz(TIME_ZONE).set({ hour: DEFAULT_CHECK_IN_HOUR, minute: DEFAULT_CHECK_IN_MINUTE, second: 0 })) && (moment(booking.checkInDate).tz(TIME_ZONE).set({ hour: DEFAULT_CUT_OFF_HOUR, minute: DEFAULT_CUT_OFF_MINUTE, second: 0 }) <= moment().tz(TIME_ZONE))))
        if (newEarlyCheckInBookings.length > 0) {
          setEarlyCheckInBookings(newEarlyCheckInBookings)
        } else {
          setEarlyCheckInBookings([])
        }
      }
    },
    onError: (error) => {
      if (!error.networkError) {
        let content = error.message
        if(error.message.includes('Validation')) {
            content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
        }
        debouncedErrorMessage(content)
      }
    }
  })
  
  if (loading) return <Spinner />;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <>
      <Helmet>
        <title>Group Check In - Rook Hotel PMS</title>
        <meta name="description" content="Group Check In - Rook Hotel PMS" />
      </Helmet>
      <SubHeader>
        <div className="title">
          <a
            className="highlight"
            href='https://pms.rookhotel.com/bookings'
            rel='noopener noreferrer'
            onClick={(event) => {
              // Handle special key combinations (Ctrl/Cmd+click)
              if (event.metaKey || event.ctrlKey) {
                // Allow default behavior (opens in new tab)
                return;
              }
              
              // Prevent default anchor behavior (full page reload)
              event.preventDefault();
              
              // Perform client-side navigation
              history.push('/bookings');
            }}
          >
            Bookings
          </a>
          {` > ${groupName}`}
          <StatusBar status={groupStatus} />
          {groupStatus === "CANCELLED" ? (
            <StatusTooltip
              createdAt={groupData.groupByID.cancelledAt}
              createdBy={groupData.groupByID.cancelledBy?.fullName}
              type={"Cancellation"}
              reason={groupData.groupByID.cancellationReason}
              amount={groupData.groupByID.cancellationFee}
            />
          ) : null}
        </div>
      </SubHeader>
      <div style={{ marginTop: '100px' }}>
        <CheckInRoutes
          earlyCheckInBookings={earlyCheckInBookings}
          name={groupName}
          status={groupStatus}
          setStatus={setGroupStatus}
        />
      </div>
      <FooterBar />
    </>
  );
}

export default GroupCheckIn;